import isAndroid from '../os/android';
import __regexp from './__firefox-regexp';
/** Detect Mozilla Firefox Android Browser */
export default function isFirefoxAndroid(ua) {
	return __regexp.test(ua) && isAndroid(ua);
}
